import React, { useEffect, useRef } from "react";
import { object, func, bool, array } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { StoryHeader } from "../../molecules";
import { StoryTags } from "../../../arrow/components/Atoms/StoryTags";
import { StoryElementCard } from "../../../arrow/components/Molecules/StoryElementCard";
import AdComponent from "../../molecules/AdComponent";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "../../pages/story.m.css";
import MoreAboutAuthors from "../../../arrow/components/Atoms/MoreAboutAuthors";

const SponsoredStory = ({ story, recommendedStories }) => {
  const { headline, authors } = story;
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const qtConfig = get(qtState, ["config"], null);
  const disclaimerText = get(qtConfig, ["publisher-attributes", "disclaimer-text"], "");
  const sponsoredBy = get(story, ["metadata", "sponsored-by"], "");
  const contentRef = useRef(null);
  const isDesktop = useDeviceType() === "desktop";

  useEffect(() => {
    if (contentRef.current) {
      const links = contentRef.current.querySelectorAll("a");

      links.forEach((link) => {
        if (link.hostname !== window.location.hostname) {
          link.setAttribute("rel", "nofollow sponsored");
          link.setAttribute("target", "_blank");
        }
      });
    }
  }, []);

  const disclaimerWithBrand = disclaimerText.replace("<sponsoring-brand>", sponsoredBy);

  return (
    <div styleName="story-template-container" ref={contentRef}>
      <StoryHeader
        story={story}
        headline={headline}
        storyAuthorData={authors}
        publishTime={story?.["published-at"]}
        readTime={story?.["read-time"]}
      />
      <div styleName="sponsored-story-elements-wrapper">
        <div styleName="cards-wrapper">
          {story.cards?.map((card, index) => {
            return (
              <div key={index}>
                <StoryElementCard
                  card={card}
                  story={story}
                  adComponent={(props) => (
                    <AdComponent
                      {...props}
                      recommendedStories={recommendedStories}
                      isDesktop={isDesktop}
                      story={story}
                    />
                  )}
                />
              </div>
            );
          })}
          {sponsoredBy && <div styleName="sponsored-by"><storng>Disclaimer:</storng> {disclaimerWithBrand}</div>}
          <StoryTags tags={story.tags} template="noBorder" story={story} />
          <MoreAboutAuthors authors={story.authors} story={story} />
        </div>
      </div>
    </div>
  );
};

SponsoredStory.propTypes = {
  story: object,
  config: object,
  adWidget: func,
  adPlaceholder: object,
  hasAccess: bool,
  recommendedStories: array,
};

export default SponsoredStory;
